import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { FireAnalyticsService } from 'src/app/services/fire-analytics.service';
import * as KeenSlider from 'keen-slider';
import { SharedService } from 'src/app/services/shared.service';
import { NewsService } from 'src/app/services/news.service';
import { AlertService } from 'src/app/services/alert.service';
import { timer } from 'rxjs';

declare let cordova: any;

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss'],
})

export class AppNewsDetailComponent implements OnInit, OnDestroy {
  @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;
  currentSlide = 0;
  isApp: boolean = environment.app;
  allNews: any[] = [];
  baseUrl = '';
  slider: any = null;
  queryData: any = {
    page: 1
  };
  totalCount = 0;
  isloading: boolean = true;
  constructor(
    private dialogRef: MatDialogRef<AppNewsDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private analytics: FireAnalyticsService,
    private sharedService: SharedService,
    private newsServie: NewsService, private alertService: AlertService
  ) {
    this.alertService.getIsMobileDevice().subscribe((res: boolean) => {
      if (!environment.app) {
        this.isApp = res;
        if (this.slider) {
          this.slider.options.vertical = true
        }
      }
    });
  }

  ngOnInit(): void {
    this.getNewsById(this.data);
  }

  ngOnDestroy() {
    if (this.slider) { this.slider.destroy(); }
  }

  intializeSlider() {
   timer(0).subscribe((res) => {
      this.slider = new KeenSlider.default(this.sliderRef.nativeElement, {
        initial: this.currentSlide,
        slides: {
          perView: 1,
          origin: 'center'
        },
        slideChanged: (event: any) => {
          this.currentSlide = event.track.details.rel;
        },
        vertical: this.isApp
      });
    });
  }

  getQueryString() {
    const obj = {
      ...this.queryData
    };
    return Object.keys(obj)
      .map((key) => key + '=' + obj[key])
      .join('&');
  }

  getAllNews = () => {
    this.sharedService.getTopNews(this.getQueryString()).subscribe((res) => {
      this.isloading = false;
      this.baseUrl = res.baseUrl;
      this.totalCount = res.totalCount;
      this.allNews = this.allNews.concat(res.data);
      this.intializeSlider();
    }, (err) => this.isloading = false);
  }

  getNewsById(id) {
    this.isloading = true;
    this.newsServie.getNewsById(id).subscribe((res) => {
      this.allNews.push(res.data);
      this.currentSlide = 0;
      this.queryData.limit = 10;
      this.getAllNews();
    });
  }

  openNews(news: any) {
    this.analytics.logEvents('Read News Link', { title: news.title });
    if (this.isApp) {
      cordova.InAppBrowser.open(news.link, '_system', 'location=yes');
    } else {
      window.open(news.link, '_blank')
    }
  }

  close() {
    this.dialogRef.close();
  }
}
